import { AsyncStatus } from 'consts'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useFetchNotesQuery } from 'store/modules/PatientNotes'

export default () => {
  const { grinDesignRefresh: grinDesignRefreshFF } = useFeatureFlags()

  const { user: patientGrinUser } = useSelector(state => state.patientsReducer.patient)
  const { data: legacyNotes, status } = useSelector(state => state.patientsReducer.notes)
  const { data: rtkNotes, isLoading } = useFetchNotesQuery(
    { patientGrinUserId: patientGrinUser?.id },
    { skip: !patientGrinUser?.id || !grinDesignRefreshFF }
  )

  const notes = useMemo(
    () => (grinDesignRefreshFF ? rtkNotes : legacyNotes),
    [grinDesignRefreshFF, rtkNotes, legacyNotes]
  )

  return {
    notes: notes,
    status: isLoading || status === AsyncStatus.Loading ? AsyncStatus.Loading : status
  }
}
